import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Modal, Popconfirm, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";
import { HomeContext } from "../../containers/Home";
import useFormHandler from "../../hooks/useFormHandler";
import { alertMessage } from "../../utils/alert";
import { GetAntIcon } from "../../utils/ant_icons";
import { getCrudaClass } from "../../utils/lookup_list";
import CustomForm from "../CustomForm";
import FormButtonSave from "../FormButtonSave";
import Emitter from "../../utils/emitter";

const PhaseReorder = (props: any) => {
	const [open, setOpen] = useState(false);
	const { currentTenantKey }: any = useContext(HomeContext);

	const { formRef, formReset, setFormReset, initialForm, resetForm } =
		useFormHandler();

	const [updated, setUpdated] = useState<boolean>(false);
	const [cancelPopover, setCancelPopover] = useState<any>(false);
	const [reorderDisabled, setReorderDisabled] = useState<boolean>(false);

	// To reset the form when the modal is open or closed
	useEffect(() => {
		const _data = { phase_data: props.data };
		if (open) {
			resetForm(_data);
		} else {
			resetForm();
		}
	}, [open]);

	const handleFormSave = async (values: any) => {
		setReorderDisabled(true);
		getCrudaClass("phase-reorder").then((cruda: any) => {
			const form = cruda.getFormList("phase-reorder");
			const formList: any = [];
			form.forEach((item: any) => {
				if (item.name) {
					formList.push(item.name);
				}
			});

			const cleanedInitialForm = Array.isArray(initialForm.phase_data)
				? initialForm.phase_data.map((item: any) => {
						return {
							_id: item._id,
							sequence_id: item.sequence_id,
							phase_name: item.phase_name,
						};
					})
				: [];

			cruda
				.updateLookupItem(
					"phase-reorder",
					props?.option,
					currentTenantKey,
					{ phase_data: values.phase_data },
					{ phase_data: cleanedInitialForm },
					props.otherData,
					props.user,
					formList
				)
				.then(() => {
					alertMessage("success", "Phase order has been successfully updated.");
					const _data = { phase_data: values.phase_data };
					resetForm(_data);
					Emitter.emit("forceUpdate", { data: _data });
					setUpdated(!updated);
					setReorderDisabled(false);
				})
				.catch(() => {
					alertMessage("error", "Changes are not saved. Please try again.");
					setReorderDisabled(false);
				});
		});
	};

	const handleFormCancel = () => {
		resetForm();
		setOpen(false);
	};

	return (
		<>
			<Button onClick={() => setOpen(true)}>
				<div
					style={{
						display: "flex",
						alignContent: "center",
						justifyContent: "center",
						gap: "5px",
					}}
				>
					{GetAntIcon("reorder")}
					<span>Reorder phases</span>
				</div>
			</Button>

			<Modal
				closable={false}
				width={"30%"}
				title={
					<>
						<span>Phase order configuration</span>{" "}
						<Tooltip
							title={"Drag and drop phases to adjust their order."}
							placement="right"
						>
							<span style={{ color: "rgba(255,255,255,0.45)" }}>
								{GetAntIcon("question3")}
							</span>
						</Tooltip>
					</>
				}
				open={open}
				centered
				destroyOnClose
				footer={() => (
					<>
						<Popconfirm
							icon={<ExclamationCircleOutlined style={{ color: "grey" }} />}
							title={
								<div style={{ maxWidth: "300px", padding: "10px" }}>
									<>
										You have unsaved changes. Discard them or continue editing?
									</>
								</div>
							}
							open={cancelPopover}
							placement="topRight"
							cancelButtonProps={{ ghost: true }}
							cancelText="Discard changes"
							onCancel={() => {
								setCancelPopover(false);
								setTimeout(() => {
									handleFormCancel();
								}, 300);
							}}
							okText="Continue editing"
							okType="default"
							onConfirm={() => {
								setCancelPopover(false);
							}}
						>
							<Button
								className="ant-btn-secondary"
								onClick={() => {
									if (formReset) {
										handleFormCancel();
									} else {
										setCancelPopover(true);
									}
								}}
							>
								Cancel
							</Button>
						</Popconfirm>
						<FormButtonSave
							form={formRef}
							handleFormSave={handleFormSave}
							formReset={formReset}
						></FormButtonSave>
					</>
				)}
			>
				<CustomForm
					setFormReset={setFormReset}
					formRef={formRef}
					tabKey={"phase-reorder"}
					dataOptions={{ phase_data: props.data }}
					formOption={props.option}
					readOnly={reorderDisabled}
				/>
			</Modal>
		</>
	);
};

export default PhaseReorder;
